import { ChevronDown } from 'lucide-react';
import { useInView } from '../../hooks/useInView';

export const Hero = ({ onBookNow }) => {
  const [ref, isInView] = useInView();

  return (
    <section
      ref={ref}
      className="relative min-h-screen flex items-center justify-center overflow-hidden">

      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1606247357835-d27fe83fc6a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzdGFycnklMjBuaWdodHxlbnwwfHx8fDE3NzAzNTg5OTR8MA&ixlib=rb-4.1.0&q=85"
          alt="Starry night sky over mountains"
          className="w-full h-full object-cover scale-105" />

        {/* Multi-layer cinematic overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-obsidian/50 to-obsidian" />
        <div className="absolute inset-0 bg-gradient-to-r from-obsidian/40 via-transparent to-obsidian/40" />
        <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-obsidian to-transparent" />
        {/* Warm vignette edges */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_40%,_#09090F_100%)]" />
      </div>

      {/* Floating warm ambient glows */}
      <div className="absolute top-1/3 left-[15%] w-[300px] h-[300px] rounded-full bg-amber/[0.03] blur-[100px] animate-breathe" />
      <div className="absolute bottom-1/4 right-[10%] w-[400px] h-[400px] rounded-full bg-amber/[0.02] blur-[120px] animate-breathe" style={{ animationDelay: '2.5s' }} />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Overline */}
        <div
          className={`mb-8 transition-all duration-1000 delay-300 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`
          }>

          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-8 h-px bg-amber/30" />
            <span className="font-body uppercase !tracking-[0.5em] text-[11px] text-amber/60">Coming to Guwahati

            </span>
            <div className="w-8 h-px bg-amber/30" />
          </div>
        </div>

        {/* Main Heading */}
        <h1
          className={`font-heading font-light leading-[0.95] mb-8 transition-all duration-[1.2s] delay-500 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`
          }>

          <span className="block sm:text-[4.5rem] md:text-[6rem] lg:text-[7.5rem] !tracking-[-0.06em] text-[3.2rem] text-ivory">
            Cinema Under
          </span>
          <span className="block sm:text-[4.5rem] md:text-[6rem] lg:text-[7.5rem] !tracking-[-0.07em] !italic text-[3.2rem] text-amber-gradient">
            the Stars
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="font-body md:text-[17px] max-w-xl transition-all duration-1000 delay-700 translate-y-0 !font-light mx-auto mb-12 opacity-100 text-[15px] text-ivory/35">An outdoor drive-in & private movie experience beside hills and a waterfall, just 35 minutes from Guwahati.





        </p>

        {/* CTA */}
        <div
          className={`transition-all duration-1000 delay-900 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
          }>

          <button
            onClick={onBookNow}
            className="btn-shimmer font-body text-[13px] font-medium tracking-[0.15em] uppercase px-10 py-4 bg-amber/90 text-obsidian rounded-full hover:bg-amber transition-colors duration-400 hover:shadow-[0_8px_40px_rgba(200,149,109,0.2)]">

            Reserve Your Evening
          </button>
          <button
            onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
            className="block mx-auto mt-5 font-body text-[12px] text-ivory/25 hover:text-amber/60 tracking-wider transition-colors duration-400">

            Discover more
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-float">
        <div className="w-px h-10 bg-gradient-to-b from-transparent to-amber/20" />
        <ChevronDown size={14} className="text-amber/25" />
      </div>
    </section>);

};